import { render, staticRenderFns } from "./UpdateBusiness.vue?vue&type=template&id=03581b2c&scoped=true&"
import script from "./UpdateBusiness.vue?vue&type=script&lang=ts&"
export * from "./UpdateBusiness.vue?vue&type=script&lang=ts&"
import style0 from "./UpdateBusiness.vue?vue&type=style&index=0&id=03581b2c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "03581b2c",
  null
  
)

export default component.exports